// Mirrors uspstfProcessArgsSchema in packages/middleware/src/cpg/
// uspstf-process.runner.ts — keep the shape in sync: { key?: string }, no key = process
// the bucket's latest import.
export function extractKey(value: unknown): unknown {
  if (typeof value === 'object' && value !== null && 'key' in value) {
    return (value as Record<string, unknown>).key
  }
  return undefined
}

export function validateUspstfProcessArgs(value: unknown): string | null {
  if (value === undefined || value === null) return null
  if (typeof value !== 'object' || Array.isArray(value)) {
    return 'Args must be an object'
  }
  const key = extractKey(value)
  if (key === undefined) return null
  if (typeof key !== 'string' || key.trim() === '') {
    return 'Archive key must be a non-empty string when set'
  }
  return null
}
